<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-card class="pt-1">
        <v-container fluid class="pa-0">
            <v-row>

                <!-- POINTS BALANCE INFO -->
                <v-col cols="12">
                    <v-card flat class="pr-4">

                        <v-container fluid class="pa-0">
                            <v-row dense>

                                <v-col cols="4" md="8" class="text-left pl-4">
                                    <help-icon class="mt-8" help="edit-panelist-rewards"></help-icon>
                                </v-col>

                                <v-col cols="4" md="2">
                                    <stat-box-numerical
                                        color="primary"
                                        :value="pointsBalance"
                                        hint="Points balance"
                                    ></stat-box-numerical>
                                </v-col>

                                <v-col cols="4" md="2">
                                    <stat-box-numerical
                                        color="grey darken-1"
                                        :value="pointsRewarded"
                                        hint="Points rewarded"
                                        :mouse-over-value="pointsRedeemed"
                                        mouse-over-hint="Points redeemed"
                                    ></stat-box-numerical>
                                </v-col>

                            </v-row>
                        </v-container>
                    </v-card>
                </v-col>

                <!-- REWARDS TABLE -->
                <v-col cols="12" class="pt-0">

                    <v-data-table
                        :headers="headers"
                        :items="data.reward_history"
                        :options.sync="tableSettings"
                        :footer-props="{itemsPerPageOptions: [10,25,100, -1]}"
                        must-sort
                    >
                        <template v-slot:body="{ items }">
                            <tbody>

                            <tr v-if="items.length===0">
                                <td colspan="100">
                                    <v-alert color="info" icon="mdi-information" class="mt-4 body-2">
                                        No rewards issued
                                    </v-alert>
                                </td>
                            </tr>

                            <tr v-for="item in items" :key="item.created_at">
                                <td>{{ item.id }}</td>
                                <td>{{ item.rewardable_type }}</td>
                                <td>{{ item.rewardable.name }}</td>
                                <td>
                                    <v-chip>{{ item.status }}</v-chip>
                                </td>
                                <td>{{ item.reward }}</td>
                                <td>{{ toLocalDateTime(item.created_at) }}</td>
                                <td>{{ toLocalDateTime(item.updated_at) }}</td>
                            </tr>
                            </tbody>
                        </template>

                    </v-data-table>

                </v-col>

                <!-- DEBUG -->
                <v-col cols="12" v-if="debug">
                    <v-card color="blue-grey darken-4">
                        <v-card-title>
                            <v-icon large class="mr-2">mdi-bug</v-icon>
                            <h3>Debug</h3>
                        </v-card-title>
                        <v-card-text>
                            <json :data="data"></json>
                        </v-card-text>
                    </v-card>
                </v-col>

            </v-row>
        </v-container>
    </v-card>
</template>

<script>

import StatBoxNumerical from "../../../../components/UI/StatBoxNumerical";
import {timeDisplay} from '../../../../components/mixins/timeDisplayMixin';
import Json from 'vue-json-pretty';
import {mapState, mapMutations} from 'vuex';
import HelpIcon from "../../../../components/UI/HelpIcon";
import TitleCard from "../../../../components/UI/TitleCard";

export default {

    mixins: [timeDisplay],

    components: {
        TitleCard,
        HelpIcon,
        Json,
        StatBoxNumerical
    },

    props: {
        data: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            debug: false,
            headers: [
                {text: 'ID', value: 'id'},
                {text: 'TYPE', value: 'rewardable_type'},
                {text: 'NAME', value: 'rewardable_name'},
                {text: 'STATUS', value: 'rewardable_code'},
                {text: 'REWARD', value: 'amount'},
                {text: 'CREATED', value: 'created_at'},
                {text: 'UPDATED', value: 'updated_at'},
            ],
        }
    },

    computed: {

        ...mapState('PanelistManager', [
            'rewardsTableSettings'
        ]),

        tableSettings: {
            get() {
                return this.rewardsTableSettings;
            },
            set(settings) {
                this.setRewardsTableSettings(settings);
            }
        },

        pointsBalance() {
            if (this.data.data_variables) {
                // POINTS_BALANCE
                let dataVar = this.data.data_variables.find(item => item.dataVariable.uuid === '7bKVueK9A2FomeRePAiKyR');
                if (dataVar) {
                    return dataVar.recorded_value;
                }
            }
            return 0;
        },

        pointsRedeemed() {
            if (this.data.data_variables) {
                // POINTS_REDEEMED
                let dataVar = this.data.data_variables.find(item => item.dataVariable.uuid === '9dhdeW4vT1ojIXleBaebx1');
                return dataVar.recorded_value;
            }
            return 0;
        },

        pointsRewarded() {
            if (this.data.data_variables) {
                // POINTS_REWARDED
                let dataVar = this.data.data_variables.find(item => item.dataVariable.uuid === '1ohdeKFvTRojIYlwWzecxl');
                return dataVar.recorded_value;

            }
            return 0;
        },

    },

    methods: {
        ...mapMutations('PanelistManager', [
            'setRewardsTableSettings'
        ])
    }
}
</script>
